/* @ngInject */
function BlockLoginsController ($scope, $translate, $timeout, $location, $stateParams, AuthService) {
  var sHost = $location.host()
  $scope.subdomain = ''
  $scope.sCustomerLogoPath = ''
  $scope.backgroundImageUrl = ''
  $scope.backgroundUrl = ''
  $scope.flags = {
    loadingLogo: true,
    loadingBackground: true
  }

  activate()

  function activate () {
    AuthService.setContainerPosition()

    if ($stateParams.supportEmail) {
      localStorage.setItem('supportEmail', $stateParams.supportEmail)
    }

    $scope.supportEmail = localStorage.getItem('supportEmail')

    $scope.isBlockLoginsMsg = $scope.supportEmail && $scope.supportEmail !== 'null'
      ? $translate.instant('userAccountBlockLoginsSupportEmailMsg', { supportEmail: $scope.supportEmail })
      : $translate.instant('userAccountBlockLoginsMsg')

    AuthService.getCustomerImages(sHost)
      .then(url => {
        $scope.subdomain = localStorage.getItem('companySubdomain')
        $scope.sCustomerLogoPath = url.logo
        $scope.backgroundUrl = url.background
      })
  }

  $scope.onLogoLoad = function () {
    $timeout(() => {
      $scope.flags.loadingLogo = false
    })
  }

  $scope.onBackgroundLoad = function () {
    $timeout(() => {
      $scope.backgroundImageUrl = $scope.backgroundUrl
      $scope.flags.loadingBackground = false
    })
  }
}

export { BlockLoginsController }
